module.exports = __webpack_public_path__ + "static/img/bg_top.604e886.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner/bg_top.png
// module id = NAN/
// module chunks = 0